/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduleListItemResponseDto
 */
export interface ScheduleListItemResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ScheduleListItemResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleListItemResponseDto
     */
    assetId: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleListItemResponseDto
     */
    assetName: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleListItemResponseDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScheduleListItemResponseDto
     */
    triggerId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleListItemResponseDto
     */
    active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleListItemResponseDto
     */
    nextDueAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ScheduleListItemResponseDto
     */
    nextDueReading?: number | null;
}

/**
 * Check if a given object implements the ScheduleListItemResponseDto interface.
 */
export function instanceOfScheduleListItemResponseDto(value: object): value is ScheduleListItemResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('assetName' in value) || value['assetName'] === undefined) return false;
    if (!('triggerId' in value) || value['triggerId'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function ScheduleListItemResponseDtoFromJSON(json: any): ScheduleListItemResponseDto {
    return ScheduleListItemResponseDtoFromJSONTyped(json, false);
}

export function ScheduleListItemResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleListItemResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetId': json['assetId'],
        'assetName': json['assetName'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'triggerId': json['triggerId'],
        'active': json['active'],
        'nextDueAt': json['nextDueAt'] == null ? undefined : (new Date(json['nextDueAt'])),
        'nextDueReading': json['nextDueReading'] == null ? undefined : json['nextDueReading'],
    };
}

export function ScheduleListItemResponseDtoToJSON(json: any): ScheduleListItemResponseDto {
    return ScheduleListItemResponseDtoToJSONTyped(json, false);
}

export function ScheduleListItemResponseDtoToJSONTyped(value?: ScheduleListItemResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetId': value['assetId'],
        'assetName': value['assetName'],
        'serialNumber': value['serialNumber'],
        'triggerId': value['triggerId'],
        'active': value['active'],
        'nextDueAt': value['nextDueAt'] == null ? value['nextDueAt'] : value['nextDueAt'].toISOString(),
        'nextDueReading': value['nextDueReading'],
    };
}

